var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#848B91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7.23C13 12.078 7 17 7 17s-6-4.923-6-9.77c0-1.652.632-3.237 1.757-4.405A5.9 5.9 0 017 1a5.9 5.9 0 014.243 1.825A6.35 6.35 0 0113 7.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9a2 2 0 100-4 2 2 0 000 4"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSI+PGcgc3Ryb2tlPSIjODQ4QjkxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHBhdGggZD0iTTEzIDcuMjNDMTMgMTIuMDc4IDcgMTcgNyAxN3MtNi00LjkyMy02LTkuNzdjMC0xLjY1Mi42MzItMy4yMzcgMS43NTctNC40MDVBNS45IDUuOSAwIDAgMSA3IDFhNS45IDUuOSAwIDAgMSA0LjI0MyAxLjgyNUE2LjM1IDYuMzUgMCAwIDEgMTMgNy4yMyIvPjxwYXRoIGQ9Ik03IDlhMiAyIDAgMSAwIDAtNCAyIDIgMCAwIDAgMCA0Ii8+PC9nPjwvc3ZnPg==";
export { SvgLocation as ReactComponent };